import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const userAccountApi = createApi({
  reducerPath: "users",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  tagTypes: ["UserAccount"],
  endpoints: (builder) => ({
    // Kullanıcı listesini getirme
    getAllUsers: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/listUsers", "POST");
      },
      providesTags: ["UserAccount"],
    }),

    // Hesap durumunu getirme
    getUserAccountStatus: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/get-account-status", "POST");
      },
      providesTags: ["UserAccount"],
    }),

    // Hesabı askıya alma
    suspendUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/suspend-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Hesabı dondurma
    freezeUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/freeze-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Hesabı devre dışı bırakma
    disableUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/disable-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Hesabı aktifleştirme
    activateUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/activate-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Kullanıcı silme
    deleteUser: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/deleteUser", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Admin personeli (AdminStaff) oluşturma
    createAdminStaff: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/create-admin-staff", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // ─── Klinik Personel Yönetimi ──────────────────────────────────
    // Klinik kapsamında personel listesi
    getAllClinicUsers: builder.query({
      query: (data) => {
        return apiFunction(data, "/api/clinic/users/listUsers", "POST");
      },
      providesTags: ["UserAccount"],
    }),

    suspendClinicUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/clinic/users/suspend-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    freezeClinicUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/clinic/users/freeze-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    disableClinicUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/clinic/users/disable-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    activateClinicUserAccount: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/clinic/users/activate-account", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    deleteClinicUser: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/clinic/users/deleteUser", "POST");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Profil güncelleme
    updateProfile: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/admin/users/update-profile", "PATCH");
      },
      invalidatesTags: ["UserAccount"],
    }),

    // Şifre değiştirme
    changePassword: builder.mutation({
      query: (data) => {
        return apiFunction(data, "/api/auth/update-password", "PATCH");
      },
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useLazyGetAllUsersQuery,
  useGetUserAccountStatusQuery,
  useSuspendUserAccountMutation,
  useFreezeUserAccountMutation,
  useDisableUserAccountMutation,
  useActivateUserAccountMutation,
  useDeleteUserMutation,
  useCreateAdminStaffMutation,
  useUpdateProfileMutation,
  useChangePasswordMutation,
  // Klinik personel yönetimi
  useGetAllClinicUsersQuery,
  useLazyGetAllClinicUsersQuery,
  useSuspendClinicUserAccountMutation,
  useFreezeClinicUserAccountMutation,
  useDisableClinicUserAccountMutation,
  useActivateClinicUserAccountMutation,
  useDeleteClinicUserMutation,
} = userAccountApi;
